/**
 * Handle problem details errors
 */
export default {
  props: {
    /**
     * Errors translation labels
     */
    errors: {
      type: Object,
      default: () => { return { Woops: 'Internal Error' } }
    }
  },
  methods: {
    /**
     * @vuese
     * Error handling function
     */
    errorHandlingAction(error) {
      this.$logger.debug(error)
      let message = this.errors.Woops
      let status = error.status
      if (error.responseJSON) {
        const { Errors, Title, Status } = error.responseJSON
        message = Title
        status = Status
        if (Errors) {
          if (Errors.__summary__) {
            message = Errors.__summary__[0]
          } else {
            const errorType = Object.keys(Errors)[0]
            message = this.errors[errorType] || this.errors.Woops
          }
        }
      } else if (error.response.data) {
        error = error.response.data
        const problemErrors = error.problem.errors
        const key = Object.keys(problemErrors)[0]
        message = problemErrors[key]
      }
      this.serverErrors.push({
        code: status,
        message
      })
    }
  }
}